var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "border rounded py-2 mb-3",
      class: [_vm.selected ? "border-success border-2" : ""],
    },
    [
      _c("div", [
        _c("div", { staticClass: "form-check mb-3" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selected,
                expression: "selected",
              },
            ],
            staticClass: "form-check-input",
            attrs: {
              type: "checkbox",
              value: "1",
              id: `order-bump-${_vm.bump.id}`,
            },
            domProps: {
              checked: Array.isArray(_vm.selected)
                ? _vm._i(_vm.selected, "1") > -1
                : _vm.selected,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.selected,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = "1",
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.selected = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.selected = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.selected = $$c
                }
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "form-check-label small fw-bold",
              attrs: { for: `order-bump-${_vm.bump.id}` },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm._f("translate")(
                      _vm.bump.checkbox_text || "Add to your order"
                    )
                  ) +
                  "\n      "
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex" }, [
        _c("div", [
          _c("img", {
            staticClass: "img-fluid rounded-1",
            staticStyle: { "max-width": "80px" },
            attrs: { src: _vm.imageUrl(_vm.bump.course.cover_photo), alt: "" },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mx-2 d-flex w-100" }, [
          _c("div", {
            staticClass: "small",
            domProps: {
              innerHTML: _vm._s(
                _vm.markdown(_vm.bump.headline || _vm.bump.course.title)
              ),
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "ms-auto text-nowrap" }, [
            _vm.bump.show_original_price
              ? _c("div", { staticClass: "text-secondary" }, [
                  _c("small", [
                    _c("del", [
                      _vm._v(
                        _vm._s(
                          _vm._f("price")(
                            _vm.bump.course.price,
                            _vm.page.currency
                          )
                        )
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c("small", [
                _vm._v(
                  _vm._s(_vm._f("price")(_vm.bump.price, _vm.page.currency))
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }